<template>
  <SoSkeleton v-if="emailContent.isFetching" height="200" />
  <template v-else>
    <SoAlert v-if="emailContent.error" type="error">
      {{ emailContent.error }}
    </SoAlert>
    <SoWidget v-else v-html="emailContent.data" />
  </template>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { CommunicationsService } from "@/services/CommunicationsService"
  import SoWidget from "@/components/SoWidget.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"
  import SoAlert from "@/components/SoAlert.vue"

  export default defineComponent({
    components: { SoWidget, SoSkeleton, SoAlert },
    props: {
      path: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        emailContent: CommunicationsService.getEmailContent(this.path),
      }
    },
  })
</script>
